import { connect } from 'react-redux';
import { compose } from 'redux';

import DeviceForm from '../components/DeviceForm';
import { deviceEntityActions, deviceEntitySelectors } from 'containers/App/modules/entities/devices/deviceEntity.slice';
import { devicesActions } from 'pages/Devices/modules/devices.slice';
import { modalActions } from 'containers/ModalRoot/modules/modal.slice';
import { hasPermission, PERMISSIONS } from 'services/PermissionsService';
import _ from 'lodash';
import { selectCountriesTreeData } from 'containers/App/modules/countries/countries.selectors';


const mapStateToProps = (state, props) => {
	const {device }= props;
	let states;

	let editBlocked;
	if (device) {
		const countries = selectCountriesTreeData(state);
		const isActiveDevice = _.get(device, 'status');
		const uiCanEditCustomer = hasPermission(PERMISSIONS.UI_EDIT_CUSTOMER_FOR_DEVICE);
		const uiCanEditCustomerForActiveDevice = hasPermission(PERMISSIONS.UI_EDIT_CUSTOMER_FOR_ACTIVE_DEVICE);
		//edit customer details if user has UI_EDIT_CUSTOMER_FOR_DEVICE and device is inactive, or device is active and user has UI_EDIT_CUSTOMER_FOR_ACTIVE_DEVICE
		const canEditCustomerDetails = !uiCanEditCustomer ? false :!isActiveDevice ? true : uiCanEditCustomerForActiveDevice;
		
		editBlocked = !canEditCustomerDetails;
		states = countries?.find(region => region.label === device?.customerDetails?.address?.region)
						  ?.children
						  ?.find(country => country.label === device.customerDetails?.address?.country)
						  ?.states;
	}
	return {
		isDeviceFetchLoading: deviceEntitySelectors.selectFetchCustomerDetailsPending(state),
		isDeviceOperationLoading: deviceEntitySelectors.selectCreateDevicePending(state),
		editBlocked,
		states,
	};
};

const withConnect = connect(mapStateToProps, {...deviceEntityActions, ...devicesActions, ...modalActions});

export default compose(
	withConnect
)(DeviceForm);